import Big from "big.js";

const CENTS_IN_DOLLAR = 100;

const getAmountWithoutCents = (value: string | number): number => {
  const isEmpty = value === "";

  if (isEmpty) {
    return 0;
  }

  const big = new Big(value).times(CENTS_IN_DOLLAR);
  const amount = big.toNumber();

  return amount;
};

export default getAmountWithoutCents;
